import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { usePostHog } from '@posthog/react';
import AuthModal from '@/components/AuthModal';
import HeroSection from '@/components/homepage/HeroSection';
import CompetitorCard from '@/components/homepage/CompetitorCard';
import TestimonialSingle from '@/components/homepage/TestimonialSingle';
import SeoVsAeoComparison from '@/components/homepage/SeoVsAeoComparison';
import WhatWeAdd from '@/components/homepage/WhatWeAdd';
import WorksEverywhere from '@/components/homepage/WorksEverywhere';
import HowItWorks from '@/components/homepage/HowItWorks';
import TestimonialsGrid from '@/components/homepage/TestimonialsGrid';
import ComparisonTable from '@/components/homepage/ComparisonTable';
import FaqSection from '@/components/homepage/FaqSection';
import FinalCta from '@/components/homepage/FinalCta';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const posthog = usePostHog();

  const onRequestAccess = () => {
    posthog?.capture('book_free_ai_visibility_review_clicked');
    window.open('https://tally.so/r/lbNMON', '_blank', 'noopener,noreferrer');
  };

  const onAuthSuccess = () => {
    setAuthOpen(false);
    navigate('/dashboard');
  };

  return (
    <div className="bg-[#fafafa]">
      <div className="flex flex-col gap-[96px] md:gap-[144px] items-center">
        {/* Hero + CompetitorCard + TestimonialSingle grouped */}
        <div className="flex flex-col gap-12 md:gap-20 items-center w-full max-w-[960px] px-4 pt-10 md:pt-16">
          <div className="flex flex-col gap-12 items-center w-full">
            <HeroSection onRequestAccess={onRequestAccess} />
            <CompetitorCard />
          </div>
          <TestimonialSingle
            quote='"...And I showed up in a ChatGPT answer within two weeks. Only difference was I put ByLLMs on my site."'
            author="David K."
            subtitle="By LLMs User"
          />
        </div>

        <SeoVsAeoComparison />

        <div className="flex flex-col gap-12 md:gap-4 items-center w-full max-w-[960px]">
          <WhatWeAdd />
          <WorksEverywhere />
        </div>

        <HowItWorks />
        <TestimonialsGrid />
        <ComparisonTable />
        <FinalCta onRequestAccess={onRequestAccess} />
        <FaqSection />
      </div>
      <div className="h-[80px]" />

      <AuthModal
        open={authOpen}
        onOpenChange={setAuthOpen}
        onSuccess={onAuthSuccess}
        defaultTab="register"
      />
    </div>
  );
};

export default HomePage;
